import React from "react"
import { SeloPremiadoFornecedorContextProvider } from "./context/SeloPremiadoFornecedorContextProvider"
import { SeloPremiadoFornecedor } from "./SeloPremiadoFornecedor"

export function Index() {
    return (
        <SeloPremiadoFornecedorContextProvider>
            <SeloPremiadoFornecedor />
        </SeloPremiadoFornecedorContextProvider>
    )
}
